export class UnidadeNegocioOptions {
    canImportErp_v1: boolean;

    /** Verifica se possui alguma opção habilitada */
    hasAnyOption(): boolean {
        return this.canImportErp_v1;
    }
}
